import { configureStore } from '@reduxjs/toolkit';

import api from './api';
import banner from './banner';
import bulkPauseUnpause from './bulk-pause-unpause';
import modal from './modal';

const redux = {
  api,
  banner,
  bulkPauseUnpause,
  modal,
  store: configureStore({
    devTools: true,
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware({
        serializableCheck: false,
      });
    },
    reducer: {
      api: api.reducer,
      banner: banner.reducer,
      bulkPauseUnpause: bulkPauseUnpause.reducer,
      modal: modal.reducer,
    },
  }),
};

export type RootState = ReturnType<typeof redux.store.getState>;

export default redux;
